export default "__VITE_ASSET__CEU5QZjs__"